export function eproviderDisplayed(providerList) {
    return {
        event: 'eproviderEvent',
        action: 'eproviderDisplayed',
        providers: providerList,
    };
}

export function eproviderClicked(providerName) {
    return {
        event: 'eproviderEvent',
        action: 'eproviderClicked',
        providers: providerName,
    };
}

export function eproviderCallback(providerName, status) {
    return {
        event: 'eproviderEvent',
        action: 'eproviderCallback',
        providers: providerName,
        status: status,
        code: '',
    };
}